import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./dashboard/Dashboard";
import AdminDashboard from "./dashboard/dashboards/admin/AdminDashboard";
import OperationControlsPage from "./dashboard/dashboards/admin/OperationControlsPage";
import ManageUsersPage from "./dashboard/dashboards/admin/ManageUsersPage";
import EventInfoPage from "./dashboard/dashboards/admin/EventInfoPage";
import EventInfoDetailPage from "./dashboard/dashboards/admin/EventInfoDetailPage";
import PickupLocationsPage from "./dashboard/dashboards/admin/PickupLocationsPage";
import SubscriptionsPage from "./dashboard/dashboards/admin/SubscriptionsPage";
import BusinessDashboard from "./dashboard/dashboards/business/BusinessDashboard";
import BusinessOrderCreationPage from "./dashboard/dashboards/business/BusinessOrderCreationPage";
import BusinessOrderDetailsPage from "./dashboard/dashboards/business/BusinessOrderDetailsPage";
import ClientDashboard from "./dashboard/dashboards/client/ClientDashboard";
import PayCsaCheckoutPage from "./dashboard/dashboards/client/PayCsaCheckoutPage";
import EmployeeDashboard from "./dashboard/dashboards/employee/EmployeeDashboard";
import DeliveriesPage from "./dashboard/pages/DeliveriesPage";
import HarvestLogPage from "./dashboard/pages/HarvestLogPage";
import HarvestManagerBusinessPage from "./dashboard/pages/HarvestManagerBusinessPage";
import OrderDetailsPage from "./dashboard/pages/OrderDetailsPage";
import OrdersPage from "./dashboard/pages/OrdersPage";
import CsaPage from "../pages/CsaPage";
import CsaSignupPage from "../pages/CsaSignupPage";
import EducationPage from "../pages/EducationPage";
import EmailVerificationPage from "../pages/EmailVerificationPage";
import EventDetailsPage from "../pages/EventDetailsPage";
import EventPage from "../pages/EventPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import HomePage from "../pages/HomePage";
import InternshipApplicationPage from "../pages/InternshipApplicationPage";
import InternshipPage from "../pages/InternshipPage";
import JoinUsPage from "../pages/JoinUsPage";
import { DemoLoginRoute } from "./DemoLoginRoute";
import { LoginRoute } from "./LoginRoute";
import ProfilePage from "../pages/ProfilePage";
import Publication from "../pages/PublicationPage";
import Publications from "../pages/PublicationsPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import MembershipDetailsPage from "../pages/MembershipDetailsPage";
import SignupPage from "../pages/SignupPage";
import SponsorsPage from "../pages/SponsorsPage";
import ToursVisitsLecturesPage from "../pages/ToursVisitsLecturesPage";
import ProjectPage from "../pages/ProjectPage";
import GalleryPage from "../pages/GalleryPage";
import MembershipsPage from "../pages/MembershipsPage";
import SupportPage from "../pages/SupportPage";
import WishlistPage from "../pages/WishlistPage";

const publicWebsiteRoutes = (
  <>
    <Route path="csa" element={<CsaPage />} />
    <Route path="csa-signup" element={<CsaSignupPage />} />
    <Route path="join" element={<JoinUsPage />} />
    <Route path="about-project" element={<ProjectPage />} />
    <Route path="events" element={<EventPage />} />
    <Route path="events/:slug" element={<EventDetailsPage />} />
    <Route path="sponsors" element={<SponsorsPage />} />
    <Route path="memberships" element={<MembershipsPage />} />
    <Route path="memberships/:slug" element={<MembershipDetailsPage />} />
    <Route path="publications" element={<Publications />} />
    <Route path="publications/:slug" element={<Publication />} />
    <Route path="education" element={<EducationPage />} />
    <Route path="education/internships" element={<InternshipPage />} />
    <Route path="gallery" element={<GalleryPage />} />
    <Route path="support-us" element={<SupportPage />} />
    <Route path="wishlist" element={<WishlistPage />} />

    <Route
      path="education/internship-application"
      element={<InternshipApplicationPage />}
    />
    <Route
      path="education/tours-visits-and-lectures"
      element={<ToursVisitsLecturesPage />}
    />
    <Route path="signup" element={<SignupPage />} />
  </>
);

const dashboardRoutes = (
  <Route path="dashboard" element={<Dashboard />}>
    <Route path="business" element={<BusinessDashboard />} />
    <Route
      path="business/orders/:orderId"
      element={<BusinessOrderDetailsPage />}
    />
    <Route path="business/new-order" element={<BusinessOrderCreationPage />} />

    <Route path="admin" element={<AdminDashboard />}>
      <Route index element={<Navigate to="deliveries" replace />} />
      <Route path="pickup-locations" element={<PickupLocationsPage />} />
      <Route path="operation-controls" element={<OperationControlsPage />} />

      <Route
        path="harvest-for-business"
        element={<HarvestManagerBusinessPage />}
      />
      <Route path="deliveries" element={<DeliveriesPage />} />
      <Route path="harvest-log" element={<HarvestLogPage />} />
      <Route path="csa-subscriptions" element={<SubscriptionsPage />} />
      <Route path="orders" element={<OrdersPage />} />
      <Route path="orders/:orderId" element={<OrderDetailsPage />} />
      <Route path="manage-users" element={<ManageUsersPage />} />
      <Route path="event-info" element={<EventInfoPage />} />
      <Route path="event-info/:eventId" element={<EventInfoDetailPage />} />
    </Route>
    <Route path="client" element={<ClientDashboard />} />
    <Route path="client/pay" element={<PayCsaCheckoutPage />} />
    <Route path="employee" element={<EmployeeDashboard />}>
      <Route index element={<Navigate to="harvest-for-business" replace />} />
      <Route
        path="harvest-for-business"
        element={<HarvestManagerBusinessPage />}
      />
      <Route path="deliveries" element={<DeliveriesPage />} />
      <Route path="orders" element={<OrdersPage />} />
      <Route path="orders/:orderId" element={<OrderDetailsPage />} />
      <Route path="harvest-log" element={<HarvestLogPage />} />
    </Route>
  </Route>
);

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="login" element={<LoginRoute />} />
      {/* Shareable demo entry point — see DemoLoginRoute. */}
      <Route path="demo" element={<DemoLoginRoute />} />
      <Route path="email-verification" element={<EmailVerificationPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="profile" element={<ProfilePage />} />
      {dashboardRoutes}
      {publicWebsiteRoutes}
    </Routes>
  );
};

export default AppRoutes;
